import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Interfaces
import {
  IParaclinico,
  TipoParaclinico,
  FiltrosParaclinicos,
  CategoriaParaclinico,
} from '../../interfaces/paraclinico.interface';

@Component({
  selector: 'app-lista-paraclinicos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './lista-paraclinicos.component.html',
  styleUrls: ['./lista-paraclinicos.component.scss'],
})
export class ListaParaclinicosComponent {
  @Input() paraclinicos: IParaclinico[] = [];
  @Input() paraclinicosCompletos: IParaclinico[] = []; // Para conteo (sin filtrar)
  @Input() paraclinicoSeleccionado: IParaclinico | null = null;
  @Input() cargando: boolean = false;

  @Output() paraclinicoSelected = new EventEmitter<IParaclinico>();
  @Output() nuevoParaclinico = new EventEmitter<void>();
  @Output() filtrosChange = new EventEmitter<FiltrosParaclinicos>();
  @Output() volver = new EventEmitter<void>();

  // Filtros locales
  filtros: FiltrosParaclinicos = {
    tipo: 'todos',
    busqueda: '',
  };

  // Tabs de tipo
  tipoSeleccionado: TipoParaclinico | 'todos' = 'todos';

  // Configuración de categorías - OPCIÓN 3: Solo bordes de color
  categorias: CategoriaParaclinico[] = [
    {
      tipo: 'interno',
      label: 'Estudio Interno',
      // Badge (se mantiene igual)
      color: '#7C3AED',
      bgColor: '#F3EEFF',
      borderColor: '#DDD6FE',
      // Card (NUEVO)
      bgCard: '#FAFAFA',
      borderCard: '#E4D5F8', // Morado
    },
    {
      tipo: 'laboratorio',
      label: 'Estudio de Laboratorio',
      // Badge (se mantiene igual)
      color: '#AE91E3',
      bgColor: '#EDE7F6',
      borderColor: '#D2BFF5',
      // Card (NUEVO)
      bgCard: '#FAFAFA',
      borderCard: '#E8D4F2', // Lavanda
    },
    {
      tipo: 'gabinete',
      label: 'Estudio de Gabinete',
      // Badge (se mantiene igual)
      color: '#D2BFF5',
      bgColor: '#DDD6FE',
      borderColor: '#C4B5FD',
      // Card (NUEVO)
      bgCard: '#FAFAFA',
      borderCard: '#D4E4F7', // Azul
    },
  ];

  // ==================== MÉTODOS ====================
  seleccionarParaclinico(paraclinico: IParaclinico): void {
    this.paraclinicoSelected.emit(paraclinico);
  }

  crearNuevo(): void {
    this.nuevoParaclinico.emit();
  }

  onVolver(): void {
    this.volver.emit();
  }

  cambiarTipoFiltro(tipo: TipoParaclinico | 'todos'): void {
    this.tipoSeleccionado = tipo;
    this.filtros.tipo = tipo;
    this.emitirFiltros();
  }

  onBusquedaChange(): void {
    this.emitirFiltros();
  }

  private emitirFiltros(): void {
    this.filtrosChange.emit({ ...this.filtros });
  }

  getCategoriaConfig(tipo?: TipoParaclinico): CategoriaParaclinico | null {
    if (!tipo) return null;
    return this.categorias.find((c) => c.tipo === tipo) || null;
  }

  getContadorPorTipo(tipo: TipoParaclinico | 'todos'): number {
    // Usar el array completo para el conteo (no el filtrado)
    const lista = this.paraclinicosCompletos.length > 0 ? this.paraclinicosCompletos : this.paraclinicos;
    if (tipo === 'todos') return lista.length;
    return lista.filter((p) => p.tipo === tipo).length;
  }

  trackByParaclinico(index: number, item: IParaclinico): string {
    return item.id || index.toString();
  }
}
